
export const SIDE_BAR_MODE = {
    BUTTON : "button-click",
    HOVER : "mouse-hover"
}

export const SIDE_BAR_ICON_SIZE = {
    SMALL : "1x",
    LARGE : "2x"
}

export const SIDE_BAR_MOUSE_EVENTS = {
    MOUSE_ENTER : "mouseenter",
    MOUSE_LEAVE : "mouseleave"
}

export const PAGE_PATH = {
    DASHBOARD: "/",
    NOTICES: 'notices',
    VIEW: 'view',
    PAYER: 'payer'
}

export const PAGE_PERMISSIONS = {
    CREATE_PAYERS: ['CreatePayer'],
    EDIT_PAYERS: ['EditPayer'],
    DELETE_PAYERS: ['DeletePayer'],
    VIEW_PAYER: ['ViewPayer'],
    CREATE_RECIPIENT: ['CreateRecipient'],
    EDIT_RECIPIENT: ['EditRecipient'],
    DELETE_RECIPIENT: ['DeleteRecipient'],
    VIEW_RECIPIENT: ['ViewRecipient'],
    CREATE_USER: ['CreateUser'],
    EDIT_USER: ['EditUser'],
    DELETE_USER: ['DeleteUser'],
    VIEW_USER: ['ViewUser'],
    VIEW_TIN_MASKING: ['ViewTINMasking'],
    CHECK_TIN_MASKING: ['CheckTINMasking'],
    W9_REQUEST: ['W9Request'],
    IMPORT_DATA: ['ImportData'],
    CREATE_FORM: ['CreateForms'],
    EDIT_FORM: ['EditForms'],
    DELETE_FORM: ['DeleteForms'],
    VIEW_FORM: ['ViewForms'],
    REVIEW_AND_APPROVE_FORMS: ['ReviewAndApproveForms'],
    SUBMIT_TO_FORMS_PAGE_FORMS: ['SubmitToFormsPageForms'],
    PRINT_FORMS: ['PrintForms'],
    EMAIL_FORMS: ['EmailForms'],
    POSTAL_EMAIL_FORMS: ['PostalMailForms'],
    PAYMENTS: ['Payment'],
    SPECIAL_MEMBER: ['SpecialMember'],
    EVENTS: ['Events'],
    SUBMIT_FOR_REVIEW: ['SubmitForReview'],
    ASSIGN_ALL_PAYERS: ['AssignAllPayers'],
    AUTO_SEND_W8: ['AutoSendW8'],
    REJECTED_FORMS: ['RejectedForms'],
    ADD_NOTICES: ['AddNotices'],
    VIEW_NOTICES: ['ViewNotices'],
    PRE_PAID: ['PrePaid'],
    IS_MNDA_SIGNED: ['IsMndaSigned'],
    SHOW_PROD_APP_KEY: ['ShowProdAppKey'],
}